// src/pages/Contact.jsx
import React, { useMemo } from "react";
import "./Contact.css";

export default function Contact() {
  // 點擊地址導向 Google Maps（可改成 dir/?api=1 做路線規劃）
  const mapQuery = useMemo(
    () => encodeURIComponent("啟鐘耳鼻喉科診所 桃園市中壢區福州一街77號"),
    []
  );
  const mapUrl = useMemo(
    () => `https://www.google.com/maps/search/?api=1&query=${mapQuery}`,
    [mapQuery]
  );

  // 小樣式：一致的行內排版與 icon 尺寸
  const rowStyle = { display: "flex", alignItems: "center", gap: 8 };
  const iconStyle = {
    width: 18,
    height: 18,
    objectFit: "contain",
    flex: "0 0 auto",
    filter: "grayscale(0)", // 需要可調色時可拿掉 PNG 用 SVG
  };

  return (
    <section className="contact-page">
      <div className="contact-inner">
        <h2 className="contact-title">聯繫我們</h2>

        <div className="contact-photo-container">
          <img className="contact-photo" src="images/work5.jpg" alt="work1" />
        </div>

        <ul className="contact-list">
          <li style={rowStyle}>
            <img
              src="/icons/phone-call.png"
              alt=""
              aria-hidden="true"
              style={iconStyle}
              loading="lazy"
            />
            <strong className="contact-label">掛號專線：</strong>
            <a href="tel:034571515">03-4571515</a>
          </li>

          <li style={rowStyle}>
            <img
              src="/icons/maps-and-flags.png"
              alt=""
              aria-hidden="true"
              style={iconStyle}
              loading="lazy"
            />
            <strong className="contact-label">地址：</strong>
            <a
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="在 Google 地圖開啟診所地址"
              title="在 Google 地圖開啟"
            >
              桃園市中壢區福州一街77號
            </a>
          </li>

          <li style={rowStyle}>
            <img
              src="/icons/facebook.png"
              alt=""
              aria-hidden="true"
              style={iconStyle}
              loading="lazy"
            />
            <strong className="contact-label">Facebook 粉專：</strong>
            <a
              href="https://www.facebook.com/profile.php?id=100064043760161"
              target="_blank"
              rel="noopener noreferrer"
            >
              前往 FB 專頁
            </a>
          </li>

          <li style={rowStyle}>
            <img
              src="/icons/instagram.png"
              alt=""
              aria-hidden="true"
              style={iconStyle}
              loading="lazy"
            />
            <strong className="contact-label">Instagram 粉專：</strong>
            <a
              href="https://www.instagram.com/chiichungclinic?igsh=aWs2ODFvYWpreDMw"
              target="_blank"
              rel="noopener noreferrer"
            >
              前往 IG 專頁
            </a>
          </li>

          <li style={rowStyle}>
            <img
              src="/icons/email.png"
              alt=""
              aria-hidden="true"
              style={iconStyle}
              loading="lazy"
            />
            <strong className="contact-label">合作信箱：</strong>
            <a href="mailto:chiichungclinic@gmail.com">
              chiichungclinic@gmail.com
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}
